import { render, staticRenderFns } from "./accident.vue?vue&type=template&id=17b93e61&scoped=true"
import script from "./accident.vue?vue&type=script&lang=js"
export * from "./accident.vue?vue&type=script&lang=js"
import style0 from "./accident.vue?vue&type=style&index=0&id=17b93e61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b93e61",
  null
  
)

export default component.exports